<!-- //
新做法
@auth xuyd
@date 2024-05-02
//-->
<template>
  <div class="define-container">
    <el-tabs value="tabWidgetTemplate" type="border-card" style="height: 100%;">
      <el-tab-pane label="组件" name="tabWidgetTemplate" style="height: 100%;">
        <el-scrollbar class="scroll-container">
          <el-collapse class="template-container" v-model="selectedCollapse" :accordion="false">
            <el-collapse-item v-for="(item, index) in widgetTemplateMenu" :key="index" :name="index">
              <div slot="title" class="title">{{ item.widgetTitle }}</div>
              <div class="template-list">
                <div class="template-item"
                     v-for="subItem in item.children"
                     :class="{dragItemLayout: true, templateWidgetList: true}"
                     :key="subItem.id"
                     draggable="true"
                     @dragstart="handleTemplateDragStart(subItem, $event)"
                     @dragend="handleTemplateDragEnd"
                >
                  <svg-icon :icon="subItem.icon"/>
                  <div class="item-title">{{ subItem.widgetTitle }}</div>
                  <div class="item-tip" v-if="subItem.maxUse > 0">{{ subItem.maxUse }}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </el-tab-pane>
      <el-tab-pane label="图层" name="tabWidgetLayer" style="height: 100%;">
        <el-scrollbar class="scroll-container">
          <draggable
              v-model="widgetViewList"
              :options="{ animation: 300 }"
          >
            <div class="template-item"
                 v-for="(layerItem, index) in widgetViewList"
                 :key="layerItem.id"
                 @mousedown="handleLayerWidgetClick(index)">
              <svg-icon :icon="layerItem.icon"/>
              <div class="item-title">{{ layerItem.widgetTitle }}</div>
            </div>
          </draggable>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  name: 'WbWidgetDefine',
  components: {
    Draggable
  },
  data() {
    return {
      selectedCollapse: 0, // 默认打开的组件面板
    }
  },
  props: {
    widgetViewList: {
      type: Array,
      default: () => {
        return []
      }
    },
    widgetTemplateMenu: {
      type: Array,
      default: () => {
        return []
      }
    },
  },

  methods: {
    /**
     * 图层点击
     * @param index
     */
    handleLayerWidgetClick(index) {
      console.log("----handleLayerWidgetClick：----->", index);
      let selectedWidget = this.widgetViewList[index];
      this.$('onclick', selectedWidget)
    },
  }
}
</script>

<style scoped lang="less">

/**template组件区域*/
.define-container {
  width: 200px;
  height: 100%;
  padding: 0;
}

.scroll-container {
  height: 100%;
}

.scroll-container .el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: scroll;
}

.template-container {
  height: auto;

  .title {
    display: block;
    padding: 10px 0;
    font-size: 14px;
    font-weight: 600;
    //color: @dv_widget_label_color;
  }

  .template-list {
    display: flex;
    flex-direction: column;
    justify-content: left;
    margin-bottom: 10px;
    padding: 10px;
  }

  .template-item {
    width: 100%;
    height: 40px;
    padding: 4px;
    font-size: 14px;
    //color: @dv_widget_label_color;
    //border: solid 1px @dv_widget_border;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;

    .item-icon {
    }

    .item-title {
      margin-left: 5px;
    }

    .item-tip {
    }

    .template-item:hover {
      cursor: pointer;
      //color: @dv_widget_active_color;
      //background-color: @dv_widget_active_background;
      box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.22);
      -webkit-box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.22);
    }

    .template-item + .template-item {
      margin-top: 10px;
    }
  }
}
</style>
